<template>
  <v-card-text>
    <v-select
      v-model="viewStyle.viewType"
      label="Способ отображения элементов"
      :items="pointViewTypes"
    />
    <template v-if="isCommonType">
      <v-card-text>
        <v-row class="d-flex align-center">
          <v-col
            v-if="icon"
            md="1"
            class="point-preview__wrapper d-flex align-center justify-center"
          >
            <img
              alt=""
              :src="icon.file.path"
              :style="{
                width: viewStyle.size * 2 + 'px',
                height: viewStyle.size * 2 + 'px',
              }"
            >
          </v-col>
          <v-col
            v-else
            md="1"
            class="point-preview__wrapper d-flex align-center justify-center"
          >
            <div
              class="point-preview"
              :style="{
                outlineColor: viewStyle.borderColor,
                outlineWidth: viewStyle.borderWidth + 'px',
                backgroundColor: viewStyle.color,
                width: viewStyle.size * 2 + 'px',
                height: viewStyle.size * 2 + 'px',
              }"
            />
          </v-col>
          <v-menu
            v-if="!icon"
            :close-on-content-click="false"
            offset-x
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :color="viewStyle.color"
                :class="[`${getTextColor(viewStyle.color)}--text`]"
                class="mr-4"
                small
                dark
                rounded
                v-bind="attrs"
                v-on="on"
              >
                Выбрать цвет точки
              </v-btn>
            </template>

            <v-card>
              <v-color-picker
                v-model="viewStyle.color"
                mode="rgba"
                flat
              />
            </v-card>
          </v-menu>
          <v-menu
            v-if="!icon"
            :close-on-content-click="false"
            offset-x
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :color="viewStyle.borderColor"
                :class="[`${getTextColor(viewStyle.borderColor)}--text`]"
                class="mr-4"
                small
                rounded
                dark
                v-bind="attrs"
                v-on="on"
              >
                Выбрать цвет контура
              </v-btn>
            </template>

            <v-card>
              <v-color-picker
                v-model="viewStyle.borderColor"
                mode="rgba"
                flat
              />
            </v-card>
          </v-menu>
        </v-row>
        <v-slider
          v-model="viewStyle.size"
          class="mt-5"
          step="1"
          min="1"
          max="20"
          thumb-label
          label="Размер точки"
          @input="setMapboxIconScale"
        />
        <v-slider
          v-if="!icon"
          v-model="viewStyle.borderWidth"
          class="mt-0"
          step="1"
          min="0"
          max="5"
          thumb-label
          label="Ширина контура точки"
        />
      </v-card-text>
    </template>
    <template v-else-if="['interpolation', 'match-colors', 'match-icons']
      .includes(viewStyle.viewType)"
    >
      <v-card-text>
        <v-select
          v-model="viewStyle.referenceProperty"
          hide-details
          return-object
          item-value="key"
          item-text="value"
          label="Поле, значение которого будет использоваться"
          no-data-text="Необходимо заполнить список полей"
          :items="mappings"
        />

        <div v-if="viewStyle.referenceProperty" class="mt-4">
          <v-slider
            v-model="viewStyle.size"
            class="mt-6"
            step="1"
            min="1"
            max="20"
            thumb-label
            label="Размер иконки"
            @input="setMapboxIconScale"
          />

          <v-slider
            v-if="viewStyle.viewType !== 'match-icons'"
            v-model="viewStyle.borderWidth"
            class="mt-0"
            step="1"
            min="0"
            max="5"
            thumb-label
            label="Ширина контура"
          />

          <template v-if="viewStyle.viewType === 'match-icons'">
            <h4>Иконки по значениям из поля:</h4>

            <v-row
              v-for="(stop, index) in viewStyle.imageStops"
              :key="index"
              class="mt-2"
            >
              <v-col md="1" class="d-flex align-self-center justify-center col">
                <img
                  v-if="preparedImageStopsIcons[stop.iconId]"
                  :src="preparedImageStopsIcons[stop.iconId].file.path"
                  :style="{
                    width: viewStyle.size * 2 + 'px',
                    height: viewStyle.size * 2 + 'px',
                  }"
                >
              </v-col>
              <v-col md="3">
                <v-text-field
                  v-model="stop.value"
                  label="Значение"
                  hide-details
                  :disabled="isMappingsEmpty"
                />
              </v-col>

              <v-col md="6">
                <icon-select-component
                  v-model="stop.iconId"
                  label="Иконка элемента"
                  :data="preparedImageStopsIcons[stop.iconId]"
                  :list="icons"
                  :disabled="isMappingsEmpty"
                />
              </v-col>

              <v-col class="pt-8 pl-0">
                <v-btn
                  color="error"
                  text
                  :disabled="isMappingsEmpty"
                  @click="viewStyle.imageStops.splice(index, 1)"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
              </v-col>
            </v-row>

            <v-row>
              <v-btn
                color="primary"
                class="mt-2"
                small
                text
                :disabled="isMappingsEmpty"
                @click="createImageStop"
              >
                Добавить иконку
              </v-btn>
            </v-row>
          </template>
          <template v-else>
            <h4>Цвета иконки по значениям из поля:</h4>
            <v-row
              v-for="(stop, index) in viewStyle.stops"
              :key="index"
              align="center"
              class="mt-2"
            >
              <v-col md="1" class="d-flex justify-center align-center">
                <div
                  class="point-preview"
                  :style="{
                    backgroundColor: stop.color,
                    width: viewStyle.size * 2 + 'px',
                    height: viewStyle.size * 2 + 'px',
                    outlineColor: stop.borderColor,
                    outlineWidth: viewStyle.borderWidth + 'px',
                  }"
                />
              </v-col>

              <v-col md="6">
                <v-text-field
                  v-model="stop.value"
                  label="Значение"
                  hide-details
                  :disabled="isMappingsEmpty"
                />
              </v-col>

              <v-col md="3">
                <v-menu
                  offset-x
                  :close-on-content-click="false"
                  :disabled="isMappingsEmpty"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-4"
                      small
                      dark
                      rounded
                      :color="stop.color"
                      :class="[`${getTextColor(stop.color)}--text`]"
                      :disabled="isMappingsEmpty"
                      v-bind="attrs"
                      v-on="on"
                    >
                      Цвет точки
                    </v-btn>
                  </template>

                  <v-card>
                    <v-color-picker
                      v-model="stop.color"
                      flat
                      :disabled="isMappingsEmpty"
                    />
                  </v-card>
                </v-menu>

                <v-menu
                  offset-x
                  :close-on-content-click="false"
                  :disabled="isMappingsEmpty"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-4"
                      small
                      dark
                      rounded
                      :color="stop.borderColor"
                      :class="[`${getTextColor(stop.borderColor)}--text`]"
                      :disabled="isMappingsEmpty"
                      v-bind="attrs"
                      v-on="on"
                    >
                      Цвет контура
                    </v-btn>
                  </template>

                  <v-card>
                    <v-color-picker
                      v-model="stop.borderColor"
                      flat
                      :disabled="isMappingsEmpty"
                    />
                  </v-card>
                </v-menu>
              </v-col>

              <v-col md="1">
                <v-btn
                  color="error"
                  text
                  :disabled="isMappingsEmpty"
                  @click="viewStyle.stops.splice(index, 1)"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
              </v-col>
            </v-row>

            <v-btn
              color="primary"
              class="mt-2"
              small
              text
              :disabled="isMappingsEmpty"
              @click="createStop"
            >
              Добавить цвет
            </v-btn>
          </template>
        </div>
      </v-card-text>
    </template>
  </v-card-text>
</template>

<script>
import IconSelectComponent from '@/components/ui/icon-select';
import getTextColor, { getHexColor } from '@/utils/get-text-color';
import { mapState } from 'vuex';

const POINT_VIEW_TYPES = [
  { value: null, text: 'Не выбрано' },
  { value: 'common', text: 'Общий' },
  { value: 'interpolation', text: 'Интерполяция цвета' },
  { value: 'match-colors', text: 'Цвет по значениям' },
  { value: 'match-icons', text: 'Иконки по значениям' },
];

const createStop = () => ({
  color: '#000000',
  borderColor: '#eeeeee',
  value: null,
});

const createImageStop = () => ({
  iconId: null,
  value: null,
});

export default {
  name: 'point-view-settings',

  components: { IconSelectComponent },

  props: {
    icon: {
      type: Object,
      default: null,
    },
    viewStyle: {
      type: Object,
      required: true,
    },
    mappings: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      pointViewTypes: POINT_VIEW_TYPES,
    };
  },

  computed: {
    ...mapState('icons', { icons: 'fullList' }),

    isMappingsEmpty() {
      return !this.mappings.length;
    },

    isCommonType() {
      return this.viewStyle.viewType === 'common';
    },

    iconTransformStyle() {
      return `translate(-50%, -50%) scale(${this.viewStyle.iconScale})`;
    },

    iconImageStopsIds() {
      return this.viewStyle.imageStops.map(i => i.iconId);
    },

    preparedImageStopsIcons() {
      if (!this.iconImageStopsIds) return null;

      return this.icons
        .filter(icon => this.iconImageStopsIds.includes(icon.id))
        .reduce((obj, item) => Object.assign(obj, { [item.id]: item }), {});
    },
  },

  watch: {
    icon: {
      immediate: true,
      handler(value) {
        if (!value) {
          this.iconWidth = 0;
        } else {
          const iconImage = new Image();

          iconImage.onload = (e) => {
            this.iconWidth = e.target.width;
            this.setMapboxIconScale(this.viewStyle.size);
          };

          iconImage.src = value.file.path;
        }
      },
    },
  },

  created() {
    this.fixColor();
  },

  methods: {
    getTextColor,

    setMapboxIconScale(radius) {
      this.viewStyle.iconScale = radius * 2 / this.iconWidth;
    },

    createStop() {
      this.viewStyle.stops.push(createStop());
    },

    createImageStop() {
      this.viewStyle.imageStops.push(createImageStop());
    },

    fixColor() {
      this.viewStyle.color = getHexColor(this.viewStyle.color);
      this.viewStyle.borderColor = getHexColor(this.viewStyle.borderColor);
    },
  },

};
</script>

<style lang="scss" scoped>
  .point-preview {
    outline-style: solid;
    border-radius: 50%;

    &__wrapper {
      height: 40px;
    }
  }
</style>
